@let $authUser = authUser();
@let $isEmergencySignIn = isEmergencySignIn();
@let $failedTask = failedTask();
@let $helpButtonMargin = helpButtonMargin();
@let $showHelpButton = showHelpButton();
@let $isAdmin = isAdmin();
@let $isHomeUser = isHomeUser();
@let $isProviderSignIn = isProviderSignIn();
@let $loadingBar = loadingBar();
@let $prefix = prefix();
@let $productMode = productMode();
@let $showButtonText = showButtonText();
@let $showShortSystemLogo = showShortSystemLogo();

<div class="mbs-header gapps-header mbs-main-menu">
  <div
    class="gapps-loading-bar"
    [class.is-hidden]="!$loadingBar.visible">
    <span
      class="gapps-loading-bar-indicator"
      [class.is-instant]="$loadingBar.instant"
      [style.width.%]="$loadingBar.progress * 100"></span>
  </div>
  <nav class="navbar navbar-light navbar-expand-apps-lg apps-navbar">
    <div class="row g-0 navbar-inner align-items-center">
      <div class="col-auto">
        <span class="fw-bold text-nowrap">
          @if (isGoogle()) {
            @if ($showShortSystemLogo) {
              {{ 'header.googleWorkspaceShort' | i18next: { format: 'capitalize' } }}
            } @else {
              {{ 'header.googleWorkspace' | i18next: { format: 'capitalize' } }}
            }
          } @else {
            @if ($showShortSystemLogo) {
              {{ 'header.microsoft365Short' | i18next: { format: 'capitalize' } }}
            } @else {
              {{ 'header.microsoft365' | i18next: { format: 'capitalize' } }}
            }
          }
        </span>
      </div>

      <div class="col-auto header-divider"></div>

      <div class="d-flex col-auto order-apps-1">
        <a
          class="navbar-brand apps-navbar_brand"
          [routerLink]="[$prefix + RoutePath.Dashboard]"
          [routerLinkActive]="'active'">
          <span
            class="ico ico-Home"
            [style.display]="'inherit'"></span>
        </a>
      </div>

      <div
        class="collapse navbar-collapse col-lg-auto order-apps-3 order-apps-lg-2"
        id="navbarSupportedContent"
        [ngbCollapse]="isNavbarCollapsed()">
        <ul class="navbar-nav mr-auto">
          @for (item of items(); track item.i18nKey) {
            <li
              class="nav-item"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: !(item.needChangeDetectionHack && userId()) }">
              <a
                class="nav-link"
                [routerLink]="[$prefix + item.link]">
                <span
                  class="nav-link_ico"
                  [class]="item.icon"></span>
                {{ item.i18nKey | i18next: { format: 'capitalize' } }}
              </a>
            </li>
          }

          <li
            class="nav-item"
            ngbDropdown
            [display]="'dynamic'"
            [placement]="'bottom-right bottom-left'"
            [routerLinkActive]="'active'">
            @if (getRouterUrl | activeRoute; as activeRoute) {
              <button
                class="nav-link -sublink"
                id="dropdownBasic2"
                ngbDropdownToggle>
                <span class="d-inline-flex align-items-center flex-row">
                  <span
                    class="nav-link_ico"
                    [ngClass]="activeRoute.iconClass"></span>

                  <span class="d-block mx-1">
                    <span class="nav-link_parent">
                      {{ 'header.reporting' | i18next: { format: 'capitalize' } }}
                    </span>
                    <span class="d-block">
                      {{ activeRoute.name }}
                    </span>
                  </span>
                </span>
              </button>
            } @else {
              <button
                class="nav-link"
                id="dropdownBasic1"
                ngbDropdownToggle>
                <span class="fa fa-bar-chart nav-link_ico"></span>
                {{ 'header.reporting' | i18next: { format: 'capitalize' } }}
              </button>
            }

            <ul
              aria-labelledby="dropdownBasic1"
              class="nav-submenu"
              ngbDropdownMenu>
              @if (!isDomainUser()) {
                <li
                  class="nav-submenu-item"
                  ngbDropdownItem
                  [routerLinkActive]="'active'">
                  <a
                    class="nav-submenu-link"
                    [routerLink]="[$prefix + RoutePath.BackupHistory]">
                    <span class="nav-link_ico fa fa-edit"></span>
                    {{ 'header.dropdown.backupHistory' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }

              <li
                class="nav-submenu-item dropdown-item"
                ngbDropdownItem
                [routerLinkActive]="'active'">
                <a
                  class="nav-submenu-link"
                  [routerLink]="[$prefix + RoutePath.History]">
                  <span class="nav-link_ico ico ico-OpenHistory"></span>
                  {{ 'header.dropdown.history' | i18next: { format: 'capitalize' } }}
                </a>
              </li>

              @if ($isAdmin || $isHomeUser) {
                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem
                  [routerLinkActive]="'active'">
                  <a
                    class="nav-submenu-link"
                    [routerLink]="[$prefix + RoutePath.Reports]">
                    <span class="nav-link_ico ico ico-Excel"></span>
                    {{ 'header.dropdown.reports' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }

              @if ($isAdmin && !$isHomeUser) {
                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem
                  [routerLinkActive]="'active'">
                  <a
                    class="nav-submenu-link"
                    [routerLink]="[$prefix + RoutePath.AuditLog]">
                    <span class="nav-link_ico fa fa-book"></span>
                    {{ 'header.dropdown.auditLog' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }

              @if (!$isProviderSignIn) {
                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem
                  [routerLinkActive]="'active'">
                  <a
                    class="nav-submenu-link"
                    [routerLink]="[$prefix + RoutePath.ExportResults]">
                    <span class="nav-link_ico fa fa-download"></span>
                    {{ 'header.dropdown.exportResults' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }

              @if ($isAdmin || $isHomeUser) {
                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem
                  [routerLinkActive]="'active'">
                  <a
                    class="nav-submenu-link"
                    [routerLink]="[$prefix + RoutePath.SkipItems]">
                    <span class="nav-link_ico fa fa-list-alt"></span>
                    {{ 'header.dropdown.skipItems' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }
            </ul>
          </li>
        </ul>
      </div>

      <div class="d-flex ml-auto col-auto order-apps-2 order-apps-lg-3 justify-content-end">
        <div class="row g-0 align-items-center justify-content-end">
          @if (isImmutability()) {
            <div
              class="col-auto header-badge"
              [class]="$isEmergencySignIn ? 'mr-2' : $showButtonText ? 'mr-4' : 'mr-2'"
              [container]="'body'"
              [ngbTooltip]="'header.tooltip.immutable' | i18next: { format: 'capitalize' }"
              [placement]="'bottom-left auto'">
              <span class="fa fa-lock text-lg"></span>
              @if ($showButtonText) {
                {{ 'header.immutable' | i18next: { format: 'capitalize' } }}
              }
            </div>
          }

          @if ($isEmergencySignIn) {
            <div
              class="col-auto header-badge mr-4"
              [container]="'body'"
              [ngbTooltip]="'header.tooltip.signedInWith' | i18next: { format: 'capitalize' }"
              [placement]="'bottom-left auto'">
              <span class="fa fa-key text-base"></span>
            </div>
          }

          <div class="col-auto">
            <a
              class="btn btn-light mr-2 position-relative"
              [routerLink]="[$prefix + RoutePath.TaskManager]"
              [routerLinkActive]="'active'">
              @if ($failedTask) {
                <span class="apps-header-update-dot">
                  {{ $failedTask | formatCount }}
                </span>
              }

              <span class="fa fa-tasks text-lg lh-base"></span>

              @if ($showButtonText) {
                {{ 'header.tasks' | i18next: { format: 'capitalize' } }}
              }
            </a>
          </div>

          <div
            #accountDropdown
            class="col-auto mr-2"
            ngbDropdown
            [class.mr-xl-0]="!$showHelpButton"
            [display]="'dynamic'"
            [placement]="'bottom-right'">
            <button
              class="btn btn-light"
              id="userMenuButton"
              ngbDropdownToggle
              [class.position-relative]="$isProviderSignIn"
              [title]="'header.account' | i18next: { format: 'capitalize' }">
              <span class="fa fa-user-o text-success text-lg"></span>

              @if ($isProviderSignIn) {
                <span class="fa fa-gear text-success text-xxs provider-icon"></span>
              }
            </button>

            <ul
              aria-labelledby="userMenuButton"
              class="nav-submenu -arrow"
              ngbDropdownMenu>
              <li
                class="nav-submenu-item mbs-navbar_userinfo disabled"
                disabled="true">
                <div class="mbs-navbar_userinfo-item text-muted">
                  <span class="fw-bold text-muted text-xs">
                    {{ 'header.dropdown.name' | i18next: { format: 'capitalize' } }}
                  </span>
                  <mbs-text-ellipsis>
                    {{ $authUser?.Name }}
                    <ng-template
                      mbsTextEllipsisAppend
                      [hide]="!$isProviderSignIn">
                      <span class="text-success ml-1">
                        {{ 'header.dropdown.provider' | i18next: { format: 'capitalize' } }}
                      </span>
                    </ng-template>
                  </mbs-text-ellipsis>
                </div>

                <div class="mbs-navbar_userinfo-item text-muted">
                  <span class="fw-bold text-muted text-xs">
                    {{ 'header.dropdown.email' | i18next: { format: 'capitalize' } }}
                  </span>
                  <mbs-text-ellipsis>
                    {{ $authUser?.Email }}
                  </mbs-text-ellipsis>
                </div>

                @if ($isProviderSignIn && $authUser?.DomainName; as domainName) {
                  <div class="mbs-navbar_userinfo-item text-muted">
                    <span class="fw-bold text-muted text-xs">
                      {{ 'header.dropdown.domainName' | i18next: { format: 'capitalize' } }}
                    </span>
                    <mbs-text-ellipsis>
                      {{ domainName }}
                    </mbs-text-ellipsis>
                  </div>
                }

                @if ($authUser?.DomainId; as domainId) {
                  <div class="mbs-navbar_userinfo-item text-muted">
                    <span class="fw-bold text-muted text-xs">
                      {{ 'header.dropdown.domainId' | i18next: { format: 'capitalize' } }}
                    </span>
                    <mbs-text-ellipsis>
                      {{ domainId }}
                    </mbs-text-ellipsis>
                  </div>
                }
              </li>

              <li class="dropdown-divider"></li>

              @if (!$isProviderSignIn) {
                <li
                  class="nav-submenu-item dropdown-item cursor-pointer"
                  ngbDropdownItem>
                  <a
                    class="nav-submenu-link"
                    (click)="handleOpenMyAccountSidepanel()">
                    <span class="nav-link_ico fa fa-user-o"></span>
                    {{ 'header.dropdown.myAccount' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }

              @if ($isAdmin || $isHomeUser) {
                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem
                  [routerLinkActive]="'active'">
                  <a
                    class="nav-submenu-link"
                    [routerLink]="[$prefix + RoutePath.RetentionPolicy]">
                    <span class="nav-link_ico ico ico-Basket"></span>
                    {{ 'header.dropdown.retentionPolicies' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              }

              <li
                class="nav-submenu-item dropdown-item"
                ngbDropdownItem
                [routerLinkActive]="'active'">
                <a
                  class="nav-submenu-link"
                  [routerLink]="[$prefix + RoutePath.TaskManager]">
                  <span class="nav-link_ico fa fa-tasks"></span>
                  {{ 'header.dropdown.taskManager' | i18next: { format: 'capitalize' } }}
                </a>
              </li>

              <li class="dropdown-divider"></li>

              <li class="nav-submenu-item mbs-navbar_userinfo">
                <div class="mbs-navbar_userinfo-item text-muted">
                  <div class="fw-bold text-muted text-xs mb-1">
                    {{ 'header.dropdown.theme.interface' | i18next: { format: 'capitalize' } }}
                  </div>
                  <div class="form-row">
                    <div class="col-auto">
                      <mbs-radio
                        [boldLabel]="false"
                        [label]="'header.dropdown.theme.light' | i18next: { format: 'capitalize' }"
                        [labelPosition]="'right'"
                        [labelSize]="MbsLabelSize.sm"
                        [ngModelOptions]="{ standalone: true }"
                        [size]="MbsSize.sm"
                        [value]="Theme.Light"
                        [(ngModel)]="theme" />
                    </div>
                    <div class="col-auto">
                      <mbs-radio
                        [boldLabel]="false"
                        [label]="'header.dropdown.theme.dark' | i18next: { format: 'capitalize' }"
                        [labelPosition]="'right'"
                        [labelSize]="MbsLabelSize.sm"
                        [ngModelOptions]="{ standalone: true }"
                        [size]="MbsSize.sm"
                        [value]="Theme.Dark"
                        [(ngModel)]="theme" />
                    </div>
                  </div>
                </div>
              </li>

              <li class="dropdown-divider"></li>

              <li
                class="nav-submenu-item dropdown-item"
                ngbDropdownItem>
                <button
                  class="nav-submenu-link"
                  (click)="handleSignAsAdmin()">
                  <span class="nav-link_ico fa fa-black-tie"></span>
                  {{ 'header.dropdown.signIn' | i18next: { format: 'capitalize' } }}
                </button>
              </li>

              <li
                class="nav-submenu-item dropdown-item"
                ngbDropdownItem>
                <button
                  class="nav-submenu-link"
                  (click)="handleLogout()">
                  <span class="fa fa-sign-out nav-link_ico"></span>
                  {{ 'header.dropdown.signOut' | i18next: { format: 'capitalize' } }}
                </button>
              </li>
            </ul>
          </div>

          @if ($showHelpButton && $productMode === ProductMode.Mbs) {
            <div class="col-auto">
              <a
                class="btn btn-light"
                [class.mr-3]="$helpButtonMargin"
                [routerLink]="[$prefix + RoutePath.Help, RoutePath.GoogleOffice365]"
                [routerLinkActive]="'active'">
                <span class="nav-link_ico fa fa-question-circle-o text-base mr-0"></span>
                {{ 'header.help' | i18next: { format: 'capitalize' } }}
              </a>
            </div>
          }

          @if ($showHelpButton && $productMode === ProductMode.Resale) {
            <div
              class="nav-item col-auto"
              ngbDropdown
              [display]="'dynamic'"
              [placement]="'bottom-right'">
              <button
                class="btn btn-light"
                id="helpMenuButton"
                ngbDropdownToggle
                [class.mr-3]="$helpButtonMargin">
                <span class="fa fa-question-circle-o text-base"></span>
                {{ 'header.help' | i18next: { format: 'capitalize' } }}
              </button>

              <ul
                aria-labelledby="helpMenuButton"
                class="nav-submenu -arrow"
                ngbDropdownMenu>
                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem>
                  <a
                    class="nav-submenu-link"
                    href="https://help.msp360.com/cloudberry-backup-for-ms-office-365"
                    target="_blank">
                    <span class="nav-link_ico fa fa-question-circle-o text-base"></span>
                    {{ 'header.help' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>

                <li
                  class="nav-submenu-item dropdown-item"
                  ngbDropdownItem>
                  <a
                    class="nav-submenu-link"
                    href="https://support.msp360.com/cases/new"
                    target="_blank">
                    <span class="nav-link_ico fa fa-life-ring"></span>
                    {{ 'header.dropdown.support' | i18next: { format: 'capitalize' } }}
                  </a>
                </li>
              </ul>
            </div>
          }
          <div class="col-auto">
            <button
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              class="navbar-toggler"
              data-target="#navbarSupportedContent"
              data-toggle="collapse"
              type="button"
              (click)="handleNavbarToggle()">
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>

<ng-template
  #alertMessageLinkTRef
  let-alert="context">
  @let link = alert.link;
  @let text = alert.text;

  @if (link && !isDomainUser()) {
    {{ text }}&nbsp;<a
      class="nowrap"
      [queryParams]="link.queryParams"
      [routerLink]="$prefix + link.path"
      (click)="handleAlertMessageLinkClick(alert.status)">
      {{ link.text }}
    </a>
  } @else {
    {{ text }}
  }
</ng-template>
